(function () {

  /* =========================
     MAPLIBRE LOADER
     ========================= */
  function loadMapLibre() {
    return new Promise(function (resolve, reject) {
      if (window.maplibregl) {
        resolve();
        return;
      }

      if (!document.querySelector('link[data-maplibre]')) {
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = "https://unpkg.com/maplibre-gl@4.7.1/dist/maplibre-gl.css";
        link.setAttribute("data-maplibre", "1");
        document.head.appendChild(link);
      }

      var script = document.createElement("script");
      script.src = "https://unpkg.com/maplibre-gl@4.7.1/dist/maplibre-gl.js";
      script.defer = true;
      script.onload = function () { resolve(); };
      script.onerror = function () { reject(); };
      document.head.appendChild(script);
    });
  }

  /* =========================
     HELPERS
     ========================= */
  function escapeHtml(str) {
    return String(str || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function cleanCoord(v) {
    if (v === null || v === undefined) return NaN;
    var s = String(v).trim().replace(/[^0-9.\-]/g, "");
    return parseFloat(s);
  }

  function formatAddress(loc) {
    var parts = [];
    if (loc.address) parts.push(loc.address);
    if (loc.city || loc.state) parts.push([loc.city, loc.state].filter(Boolean).join(", "));
    if (loc.zip) parts.push(loc.zip);
    return parts.join(" ");
  }

  function directionsUrl(loc) {
    var q = encodeURIComponent((loc.name + " " + formatAddress(loc)).trim());
    return "https://www.google.com/maps/dir/?api=1&destination=" + q;
  }

  /* =========================
     CARD TEMPLATE (NO $)
     ========================= */
  function cardHtml(loc) {
    return (
      '<div class="ritual-locator__card js-rl-card" tabindex="0" data-id="' + escapeHtml(loc.id) + '">' +
        '<div class="ritual-locator__name">' + escapeHtml(loc.name) + '</div>' +
        '<div class="ritual-locator__meta">' + escapeHtml(formatAddress(loc)) + '</div>' +
        '<div class="ritual-locator__actions">' +
          '<a class="ritual-locator__link" href="' + directionsUrl(loc) + '" target="_blank">Directions</a>' +
        '</div>' +
      '</div>'
    );
  }

  /* =========================
     INIT
     ========================= */
  function init(section) {
    var dataEl = section.querySelector(".js-rl-data");
    if (!dataEl) return;

    var config = JSON.parse(dataEl.textContent || "{}");
    var mapEl = section.querySelector(".js-rl-map");
    var listEl = section.querySelector(".js-rl-list");
    var countEl = section.querySelector(".js-rl-count");

    var raw = Array.isArray(config.locations) ? config.locations : [];

    var locations = [];
    for (var i = 0; i < raw.length; i++) {
      var lat = cleanCoord(raw[i].lat);
      var lng = cleanCoord(raw[i].lng);
      if (!isNaN(lat) && !isNaN(lng)) {
        raw[i].lat = lat;
        raw[i].lng = lng;
        locations.push(raw[i]);
      }
    }

    listEl.innerHTML = "";
    for (var j = 0; j < locations.length; j++) {
      listEl.innerHTML += cardHtml(locations[j]);
    }

    countEl.textContent = String(locations.length);

    loadMapLibre().then(function () {

      var map = new maplibregl.Map({
        container: mapEl,
        style: {
          version: 8,
          sources: {
            carto: {
              type: "raster",
              tiles: [
                "https://a.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png",
                "https://b.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png"
              ],
              tileSize: 256
            }
          },
          layers: [{ id: "base", type: "raster", source: "carto" }]
        },
        center: [locations[0].lng, locations[0].lat],
        zoom: 11
      });

      var markers = {};

for (var k = 0; k < locations.length; k++) {
  (function (loc) {

    // Create a custom DOM element for the marker
    var el = document.createElement("div");
    el.className = "ritual-pin ritual-pin--glow";
    el.innerHTML = '<span class="ritual-pin__core"></span>';

    // Create the marker using *your* element (prevents default blue pins)
    var marker = new maplibregl.Marker({ element: el, anchor: "center" })
      .setLngLat([loc.lng, loc.lat])
      .addTo(map);

    markers[loc.id] = marker;

    el.addEventListener("click", function () {
      map.flyTo({ center: [loc.lng, loc.lat], zoom: 13 });
    });

  })(locations[k]);
}


      var cards = section.querySelectorAll(".js-rl-card");
      for (var m = 0; m < cards.length; m++) {
        cards[m].addEventListener("mouseenter", function () {
          var id = this.getAttribute("data-id");
          var loc = locations.find(function (l) { return l.id === id; });
          if (loc) map.flyTo({ center: [loc.lng, loc.lat], zoom: 12 });
        });
      }

    });
  }

  /* =========================
     BOOTSTRAP
     ========================= */
  function boot() {
    var sections = document.querySelectorAll(".ritual-locator");
    for (var i = 0; i < sections.length; i++) {
      if (!sections[i].dataset.init) {
        sections[i].dataset.init = "1";
        init(sections[i]);
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", boot);

})();
